<template>
  <div class="info-box info-box-big d-flex mb-4 flex-wrap flex-sm-nowrap">
    <div class="info-box-title">
      <div>
        <a href="https://dogovori.adminplus.bg/Products" target="_blank">
          <component :is="data.iconComponent"></component>
        </a>
      </div>
    </div>
    <div class="info-box-content">
      <div class="align-items-center d-flex h-100 info-box-head">
        <h5 v-html="data.title"></h5>
      </div>
      <div class="d-none d-sm-flex flex-column h-100 info-box-body justify-content-center">
        <div v-if="data.subtitle" class="mb-1 px-4">
          {{ data.subtitle }}
        </div>
        <div>
          <ul class="mb-0 pl-4">
            <li v-for="(details, index) in data.details" :key="`details${index}`">
              {{ details.text }}
              <ul v-if="details.details" class="pl-4">
                <li v-for="(subDetails, subIndex) in details.details" :key="subIndex">
                  {{ subDetails.text }}
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="d-flex flex-column justify-content-center display-sm-hidden info-box-body">
      <div v-if="data.subtitle" class="mb-1 px-4">
        {{ data.subtitle }}
      </div>
      <div>
        <ul class="mb-0 pl-4">
          <li v-for="(details, index) in data.details" :key="`details2${index}`">
            {{ details.text }}
            <ul v-if="details.details" class="pl-4">
              <li v-for="(subDetails, subIndex) in details.details" :key="subIndex">
                {{ subDetails.text }}
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import DnevnikIcon from "./icons/dnevnik-icon";
import StudentIcon from "./icons/student-icon";
import MessagesIcon from "./icons/messages-icon";
import CalendarIcon from "./icons/calendar-icon";
import DocumentsIcon from "./icons/documents-icon";
import AscIcon from "./icons/asc-icon";
import MobileIcon from "./icons/mobile-icon";
import AbsenceIcon from "./icons/absence-icon";
import AdminIcon from "./icons/admin-icon";
import ResourceIcon from "./icons/resource-icon";
import KindergartenIcon from "./icons/kindergarten-icon";
import ParentIcon from "./icons/parent-icon";
import TaxMealsIcon from './icons/tax-meals-icon';
import NutritionIcon from './icons/nutrition-icon';
import SoIcon from './icons/so-icon';
import KdIcon from './icons/kd-icon';
import ReportIcon from './icons/report-icon';
import PersonalIcon from './icons/personal-icon'
import ProtocolsIcon from './icons/protocols-icon'
import DiplomaIcon from './icons/diploma-icon'

export default {
  name: "modules-single-component",
  components: {
    PersonalIcon,
    ParentIcon,
    KindergartenIcon,
    ResourceIcon,
    AdminIcon,
    AbsenceIcon,
    MobileIcon,
    AscIcon,
    DocumentsIcon,
    CalendarIcon,
    MessagesIcon,
    StudentIcon,
    DnevnikIcon,
    SoIcon,
    KdIcon,
    ReportIcon,
    TaxMealsIcon,
    NutritionIcon,
    ProtocolsIcon,
    DiplomaIcon
  },
  props: {
    data: Object
  },
}
</script>

<style scoped>
</style>
